import React from 'react';
import { partnerLogos } from '../data/mock';

const PartnersSection = () => {
  return (
    <section
      id="partners"
      className="section-spacing-large"
      style={{ backgroundColor: 'var(--color-carbon)' }}>

      <div className="container-artworld">
        {/* Section Title */}
        <div className="text-center mb-16">
          <p className="label-text mb-4"></p>
          <h2 className="section-title">Nos interventions</h2>
          <p className="body-text max-w-3xl mx-auto mt-6">
            Nous collaborons avec des professionnels passionnés qui partagent notre amour de l'automobile. 
            Photographes, préparateurs, spécialistes du detailing ou du covering, chacun apporte son savoir-faire 
            et contribue à mettre en valeur l'univers automobile. Découvrez les partenaires qui accompagnent 
            et soutiennent notre communauté.
          </p>
          <div
            className="w-24 h-1 mx-auto mt-6"
            style={{
              background: 'linear-gradient(90deg, transparent, var(--color-red-accent), transparent)'
            }} />

        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {partnerLogos.map((partner) =>
          <div
            key={partner.id}
            className="group relative p-8 flex flex-col items-center justify-center"
            style={{
              background: 'var(--color-black)',
              border: '1px solid var(--color-dark-gray)',
              transition: 'all var(--transition-normal)',
              minHeight: '280px'
            }}>

              {/* Hover Effect */}
              <div
              className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              style={{
                background: 'linear-gradient(135deg, rgba(220, 38, 38, 0.1) 0%, transparent 100%)',
                border: '1px solid var(--color-red-accent)'
              }} />


              {/* Logo */}
              <div className="relative z-10 mb-6 w-full h-40 flex items-center justify-center">
                <img
                src={partner.logo}
                alt={partner.name}
                className="max-w-full max-h-full object-contain transition-transform duration-500 group-hover:scale-105"
                style={{ filter: 'brightness(1.1)' }} />

              </div>

              {/* Partner Name */}
              <h3
              className="relative z-10 subtitle text-center mb-2"
              style={{
                fontSize: '1rem',
                color: 'var(--color-white)',
                letterSpacing: '0.02em'
              }}>

                {partner.name}
              </h3>

              {/* Description */}
              <p className="relative z-10 caption-text text-center">
                {partner.description}
              </p>
            </div>
          )}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="body-text mb-8 max-w-2xl mx-auto">
            Vous êtes un professionnel de l'automobile et souhaitez rejoindre notre réseau de partenaires ? 
            Contactez-moi pour discuter d'une collaboration.
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="btn-accent">

            Devenir Partenaire
          </button>
        </div>
      </div>
    </section>);

};

export default PartnersSection;